import type { AddFieldOption } from '@cli-types/core-engine/add-field.js'

export function parseAddFieldOption(value: string): AddFieldOption {
  const separatorIndex = value.indexOf(':')
  if (separatorIndex <= 0 || separatorIndex === value.length - 1) {
    throw new Error(`Invalid option "${value}". Use value:Label.`)
  }

  const optionValue = value.slice(0, separatorIndex).trim()
  const label = value.slice(separatorIndex + 1).trim()

  if (!optionValue || !label) {
    throw new Error(`Invalid option "${value}". Use value:Label.`)
  }

  return {
    value: optionValue,
    label
  }
}
